import { useMediaQuery, useTheme } from '@mui/material';
import Link from 'next/link';
import React from 'react';
import Image from 'next/image';

const brands = [
	{
		brandId: '655895a98a3a7472cad844ef',
		logoPath: 'https://i.imgur.com/5MpbxU2.png',
		bgColor: '#00BFFF',
		width: 90,
		mobileWidth: 90,
		height: 59,
		mobileHeight: 40,
	},
	{
		brandId: '655896978a3a7472cad844f1',
		logoPath: 'https://i.imgur.com/kVg9A0v.png',
		bgColor: '#9C6',
		width: 120,
		mobileWidth: 114,
		height: 50,
		mobileHeight: 45,
	},
	{
		brandId: '6557c5116b0bf98d0a0e0d2a',
		logoPath: 'https://i.imgur.com/PH4wdvU.png',
		bgColor: '#FC0',
		width: 150,
		mobileWidth: 135,
		height: 27,
		mobileHeight: 27,
	},
	{
		brandId: '655897998a3a7472cad844f7',
		logoPath: 'https://i.imgur.com/tJETgwo.png',
		bgColor: '#B332E6',
		width: 210,
		mobileWidth: 140,
		height: 25,
		mobileHeight: 22,
	},
	{
		brandId: '655bbbe5cdc1bddb7580b79a',
		logoPath: 'https://i.imgur.com/n3lOUn7.png',
		bgColor: '#00BFFF',
		width: 180,
		mobileWidth: 140,
		height: 23,
		mobileHeight: 23,
	},
];

const BrandCards = () => {
	const theme = useTheme();
	const isXl = useMediaQuery(theme.breakpoints.down('xl'));
	const isLg = useMediaQuery(theme.breakpoints.down('lg'));
	const isMd = useMediaQuery(theme.breakpoints.down('md'));
	const isSm = useMediaQuery(theme.breakpoints.down('sm'));
	const isXs = useMediaQuery(theme.breakpoints.down('xs'));

	const getBrandsToRender = () => {
		if (isMd || isSm || isXs) return brands;
		else if (isLg) return brands.slice(0, 3);
		else if (isXl) return brands.slice(0, 4);
		return brands;
	};

	return (
		<div
			className={`flex gap-2 ${
				isMd ? 'flex-nowrap overflow-auto' : 'justify-center'
			}`}
		>
			{getBrandsToRender().map((brand, i) => (
				<div
					key={brand?.brandId}
					className='flex-grow-0 flex-shrink-0 basis-auto md:flex-grow md:basis-0 w-1/2 mb-2'
				>
					<Link
						href={`/brand/${brand?.brandId}`}
						style={{ all: 'unset' }}
					>
						<div
							style={{
								cursor: 'pointer',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								borderRadius: '10px',
								backgroundColor: brand.bgColor,
								textAlign: 'center',
								fontSize: '24px',
								fontWeight: 700,
								height: '70px',
							}}
						>
							<Image
								alt={`${brand?.brandId} logo`}
								src={brand.logoPath}
								width={isMd ? brand.mobileWidth : brand.width}
								height={isMd ? brand.mobileHeight : brand.height}
								style={{
									objectFit: 'contain',
									maxWidth: '100%',
									height: 'auto',
								}}
								loading='lazy'
							/>
						</div>
					</Link>
				</div>
			))}
		</div>
	);
};

export default BrandCards;
